// CSV utilities for admin exports
function escapeCSV(value) {
  if (value === null || value === undefined) return "";
  const s = String(value);
  if (/[",\n\r]/.test(s)) return `"${s.replace(/"/g, '""')}"`;
  return s;
}

export function downloadCSV(filename, headers, rows) {
  const headerRow = headers.map((h) => escapeCSV(h.label)).join(",");
  const dataRows = rows.map((r) =>
    headers.map((h) => escapeCSV(typeof h.value === "function" ? h.value(r) : r[h.key])).join(",")
  );
  const csv = [headerRow, ...dataRows].join("\r\n");
  const blob = new Blob(["\uFEFF" + csv], { type: "text/csv;charset=utf-8;" });
  const url = URL.createObjectURL(blob);
  const a = document.createElement("a");
  a.href = url;
  a.download = filename;
  document.body.appendChild(a);
  a.click();
  document.body.removeChild(a);
  URL.revokeObjectURL(url);
}

export function formatDate(s) {
  if (!s) return "";
  try {
    const d = typeof s === "string" ? new Date(s) : s;
    return d.toLocaleString("en-IN", { day: "2-digit", month: "short", year: "numeric", hour: "2-digit", minute: "2-digit" });
  } catch {
    return String(s);
  }
}
